import { createStore, createEvent, Event } from 'effector';

export const DEFAULT_LOCALE_WEIGHT = (localStorage.getItem('localeWeight') as LOCALE) || 'ru';

export const setLocaleWeight: Event<LOCALE> = createEvent('Select Locale Weight');
export const resetLocaleWeight = createEvent('Reset Locale Weight');

const setLocaleHandler = (state: LOCALE, localeName: LOCALE) => localeName;
const resetLocaleHandler = () => DEFAULT_LOCALE_WEIGHT;

const localeWeight = createStore<LOCALE>(DEFAULT_LOCALE_WEIGHT)
  .on(setLocaleWeight, setLocaleHandler)
  .on(resetLocaleWeight, resetLocaleHandler);

localeWeight.watch((localeName: LOCALE) => {
  localStorage.setItem('localeWeight', localeName);
});

export enum LOCALE {
  RU = 'ru',
  EN = 'en',
  EN_RU = 'en-RU',
  FR = 'fr',
  KO = 'ko',
  ES = 'es',
  PT_BR = 'pt-br',
  DE = 'de',
  TH = 'th',
  JA = 'ja',
  IT = 'it',
  ZH = 'zh',
  ALL = 'all',
}

export const LOCALE_NAME: Record<LOCALE, string | string[] | undefined> = {
  [LOCALE.RU]: 'RU',
  [LOCALE.EN]: 'EN',
  [LOCALE.EN_RU]: 'en-RU',
  [LOCALE.FR]: 'FR',
  [LOCALE.KO]: 'KO',
  [LOCALE.ES]: 'ES',
  [LOCALE.PT_BR]: 'PT-BR',
  [LOCALE.DE]: 'DE',
  [LOCALE.TH]: 'TH',
  [LOCALE.JA]: 'JA',
  [LOCALE.IT]: 'IA',
  [LOCALE.ZH]: 'ZH',
  [LOCALE.ALL]: 'ALL',
};

export const ALL_LOCALE = Object.entries(LOCALE).map(([key, value]) => value);

export const localeWeightMap: Record<LOCALE, { name: string }> = Object.entries(LOCALE).reduce(
  (prev, [key, value]) => {
    return {
      ...prev,
      [value]: {
        name: LOCALE_NAME[value],
      },
    };
  },
  {} as Record<LOCALE, { name: string }>,
);

export default localeWeight;
